export enum ActionType {
  API_DEV_TOOLING_DETAILS_BY_PID = "API_DEV_TOOLING_DETAILS_BY_PID",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IAPIToolingProjectDetailsByPid {
  type: ActionType.API_DEV_TOOLING_DETAILS_BY_PID;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IAPIToolingProjectDetailsByPid | IResetReduxState;
